
import "slick-carousel";

$('.image-carousel-slider').slick({
    infinite: false,
    arrows: true,
    speed: 300,
    prevArrow: $('.image-carousel-slider-prev'),
    nextArrow: $('.image-carousel-slider-next'),
    slidesToShow: 3,
    slidesToScroll: 1,
    touchThreshold: 100,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          dots: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true
        }
      },
      {
        breakpoint: 520,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true
        }
      }
    ]
  });